module.exports = __webpack_public_path__ + "static/media/29COICT6.121644d4.jpg";